const exploreMeShow = should_show => {
	const explore_me_message = document.getElementById("explore-me-message")

	if(!explore_me_message){
		return
	}

	console.log('exploreMeShow', should_show)

	if(should_show){
		explore_me_message.classList.remove('hidden')
	} else {
		explore_me_message.classList.add('hidden')
	}
}


export default exploreMeShow
